import React, { useState, useEffect } from "react";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faX, faCreditCard, faSquareCheck, faReceipt, faUser, faHouse, faTrophy, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import {constants} from "../core/data/constants";
import { navLinks } from "../core/data/constants";
import DarkMode from "./DarkMode";
import Button from "../core/components/Button";
import DarkLogo from "../core/assets/img/logoDark.png"
import LightLogo from "../core/assets/img/logoLight.png"
//import { useAppContext } from "../core/lib/ContextLib";
const Navbar = ({ setTheme }) => {
    const [menu, setMenu] = useState(false);
    const [theme, setLocalTheme] = useState(localStorage.getItem("theme") || "dark");
    
    const location = useLocation();
    const navigate = useNavigate();
    //const { isAuthenticated } = useAppContext();
    const websiteLogo = constants[0].websiteLogo
    const websiteName = constants[0].websiteName 
    const logoSite = `Logo de ${websiteName}`
    

    const updateTheme = () => {
        const newTheme = theme === "dark" ? "light" : "dark";
        setLocalTheme(newTheme);
        setTheme(newTheme); // Pass the theme up to App.js
        localStorage.setItem("theme", newTheme);
      };

      useEffect(() => {
        const element = document.documentElement;
        element.classList.toggle("dark", theme === "dark");
      }, [theme]);

      const logoSrc = theme === "dark" ? DarkLogo : LightLogo;

    useEffect(() => {
        if (location.hash) {
            const targetId = location.hash.substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                // Simulate a click on the corresponding ScrollLink
                //simulateClick(`scroll-${targetId}`);
                // Clean the hash from the URL after scrolling
                navigate(location.pathname, { replace: true });

                // Add a delay before simulating a click on the corresponding ScrollLink
                setTimeout(() => {
                    simulateClick(`scroll-${targetId}`);
                }, 500);
            }
        }
}, [location.hash, navigate]);

    const handleChange = () => {
        setMenu(!menu);
    };

    const closeMenu = () => {
        setMenu(false);
    };

function simulateClick(id) {
    const link = document.getElementById(id);
    if (link) {
        link.click();
    }
}

const handleLinkClick = () => {
    closeMenu();
    scroll.scrollToTop();
};

const handleThemeChange = (newTheme) => {
    setTheme(newTheme);
};


    return (
        <div className="z-20 fixed w-full flex flex-row items-center backdrop-blur-sm">
        <div className="w-full  text-black dark:text-white p-4 ">
                <div className="w-full h-1/2 flex flex-row justify-between text-center items-center  p-2 lg:px-32 px-5">
                
                    {/*logo*/}
                    <div className="flex flex-row items-center cursor-pointer gap-2 mr-4">
                        {location.pathname === '/' ? (
                            <ScrollLink to="top" spy={true} smooth={true} duration={500} className=" rounded-full mx-auto" onClick={scroll.scrollToTop}>
                                
                                <img className="h-14 " src={logoSrc} alt={logoSite}  title={logoSite} loading="lazy"/>
                                
                                
                            </ScrollLink>
                        ) : (
                            <RouterLink to={'/'} aria-label="Home" className=" rounded-full mx-auto" onClick={scroll.scrollToTop}>
                                
                                <img className="h-14 " src={logoSrc} alt={logoSite}  title={logoSite} loading="lazy"/>
                                
                         
                            </RouterLink>
                        )}
                    </div>

                    {/* Navbar Letters */}
                    <nav className="hidden sm:flex flex-row items-center md:text-base lg:text-lg font-medium gap-2">
                        {navLinks.map((navlink) => (
                            location.pathname === '/' ? (
                                <ScrollLink
                                    key={navlink.id}
                                    to={navlink.id}
                                    spy={true}
                                    smooth={true}
                                    duration={500}
                                    offset={-80}
                                    id={`scroll-${navlink.id}`}
                                    className="group relative inline-block cursor-pointer hover:text-darkaccent  pr-2"
                                    onClick={closeMenu}
                                >
                                    {navlink.title}
                                    <span className="absolute inset-x-0 bottom-0 h-0.5 bg-darkaccent transform scale-x-0 origin-left transition-transform group-hover:scale-x-100"></span>
                                </ScrollLink>
                            ) : (
                                <RouterLink
                                    key={navlink.id}
                                    to={{ pathname: '/', hash: navlink.id }}
                                    className="group relative inline-block cursor-pointer hover:text-darkaccent  pr-2"
                                    onClick={closeMenu}
                                >
                                    {navlink.title}
                                    <span className="absolute inset-x-0 bottom-0 h-0.5 bg-darkaccent transform scale-x-0 origin-left transition-transform group-hover:scale-x-100"></span>
                                </RouterLink>
                            )
                        ))}
                    </nav>


                    <div className="flex flex-row items-center gap-4">
                        <DarkMode theme={theme} updateTheme={updateTheme}/>
                        {/* 
                        <button className='px-6 py-1 
                        bg-primary dark:bg-darkprimary text-darktext dark:text-text hover:bg-primary/90 dark:hover:bg-darkprimary/90
                          transition-all rounded-full'>
                    Comienza Ahora
                    </button>
                    */}
                    </div>
                
             
            </div>
            
            </div>
            </div>
    );
};

export default Navbar;